module.exports = __webpack_public_path__ + "static/img/1.e3dab9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/1.jpg
// module id = Ec1F
// module chunks = 1